var _a;
import { __awaiter } from "tslib";
import $ from 'jquery';
import { Foundation } from 'foundation-sites/js/foundation.core';
import { Reveal } from 'foundation-sites/js/foundation.reveal';
import { Dropdown } from 'foundation-sites/js/foundation.dropdown';
import { Interchange } from 'foundation-sites/js/foundation.interchange';
import { MediaQuery } from 'foundation-sites/js/foundation.util.mediaQuery';
import { Toggler } from 'foundation-sites/js/foundation.toggler';
import { rtl } from 'foundation-sites/js/foundation.core.utils';
import { formatDateElement, formatNumberElement, formatRelativeDateElement } from 'irep/utilities/intl';
import { readOptions } from 'irep/utilities/helpers';
import { FullPageQuiz } from 'irep/modules/education/full-page-quiz';
import { NonEduVideoTracking } from 'irep/modules/videotracking/video-tracking';
const IREP = (_a = class IREP {
        constructor() { }
        static setupJquery() {
            $.ajaxSetup({
                cache: false
            });
        }
        static setupSelect2() {
            $("select").each((i, elem) => {
                $(elem).select2(Object.assign({ rtl: rtl() }, readOptions(elem)));
            });
            $(document).on('select2:open', () => {
                const openSearchBox = document.querySelector('.select2-container--open .select2-search__field');
                if (openSearchBox) {
                    openSearchBox.focus();
                }
            });
        }
        static initialize(options, initializer) {
            this.options = options;
            this.setupJquery();
            this.formatDateTimes();
            this.formatNumbers();
            this.setNonEduVideoTracking();
            Foundation.plugin(Reveal, 'Reveal');
            Foundation.plugin(Dropdown, 'Dropdown');
            Foundation.plugin(MediaQuery, 'MediaQuery');
            Foundation.plugin(Interchange, 'Interchange');
            Foundation.plugin(Toggler, 'Toggler');
            $(document).foundation();
            this.setupSelect2();
            window.irep = _a;
            initializer.execute();
            $(window).on('popstate', () => {
                const code = localStorage.getItem("code");
                if (localStorage.getItem("closed") === "false" && code !== "") {
                    this.closeFullPageQuiz("partial", code);
                }
                else if (history.state && history.state.start) {
                    history.replaceState(null, "");
                    history.back();
                }
            });
        }
        static formatDateTimes() {
            $("time").each((_, elem) => {
                formatDateElement(elem);
            });
            this.showRelativeDates();
        }
        static formatNumbers() {
            $("span[data-number]").each((_, elem) => {
                formatNumberElement(elem);
            });
        }
        static showRelativeDates() {
            $.each($(".moment"), (_, item) => {
                formatRelativeDateElement(item);
            });
        }
        static generateSiteLink(path, full = false) {
            const root = full ? window.irep.options.irepUrl : window.irep.options.appUrl;
            return root + window.irep.options.user.site + path;
        }
        static getBrowser() {
            const ua = navigator.userAgent;
            let tem, M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
            if (/trident/i.test(M[1])) {
                tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
                return { name: 'IE', version: (tem[1] || '') };
            }
            if (M[1] === 'Chrome') {
                tem = ua.match(/\bOPR|Edge\/(\d+)/);
                if (tem != null) {
                    return { name: 'Opera', version: tem[1] };
                }
            }
            M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
            if ((tem = ua.match(/version\/(\d+)/i)) != null) {
                M.splice(1, 1, tem[1]);
            }
            return {
                name: M[0],
                version: M[1]
            };
        }
        static callApi(options) {
            options = $.extend({}, { type: 'GET', secure: false, anonymous: false, data: {}, headers: {} }, options);
            const headers = $.extend({}, { "PaxUID": options.anonymous ? '' : this.options.user.currentUID }, options.headers);
            return $.ajax({
                dataType: "json",
                url: this.options.apiUrlSecure + options.url,
                contentType: 'application/json',
                type: options.type,
                headers: headers,
                traditional: options.traditional,
                data: options.type === "POST" ? JSON.stringify(options.data) : options.data
            });
        }
        static postFormData(options) {
            return __awaiter(this, void 0, void 0, function* () {
                options = $.extend({}, { bypassCDN: false, traditional: false, type: 'GET', secure: false, anonymous: false, async: true, cache: false, contentType: true, timeout: 15000, data: {}, headers: {}, dataType: "html" }, options);
                let headers = $.extend({}, options.headers);
                const root = options.bypassCDN ? this.options.appUrlBypassCDN : this.options.appUrlSecure;
                const site = options.site !== false ? this.options.user.site + '/' : '';
                if (options.bypassCDN && !options.anonymous) {
                    const t = yield this.getOTUT();
                    headers = $.extend({}, { "PaxUID": t.token }, options.headers);
                }
                return yield $.ajax({
                    dataType: options.dataType,
                    url: `${root}${site}${options.url}`,
                    contentType: options.contentType ? 'application/json' : false,
                    type: options.type,
                    processData: options.processData,
                    async: options.async,
                    cache: options.cache,
                    timeout: options.timeout,
                    headers: headers,
                    traditional: options.traditional,
                    data: options.data
                });
            });
        }
        static fetch(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const url = new URL(`${this.options.appUrlSecure}/${this.options.user.site}/${options.url}`, options.bypassCDN ? this.options.appUrlBypassCDN : window.location.origin);
                const method = options.type || "GET";
                const headers = Object.assign({ 'content-type': 'application/json' }, options.headers);
                const fetchOptions = { method: method, headers: headers, };
                if (options.data) {
                    if (method === "GET") {
                        Object.entries(options.data)
                            .forEach(([key, value]) => { url.searchParams.append(key, String(value)); });
                    }
                    else {
                        fetchOptions.body = JSON.stringify(options.data);
                    }
                }
                const response = yield fetch(url.toString(), fetchOptions);
                return yield response.json();
            });
        }
        static getOTUT() {
            return __awaiter(this, void 0, void 0, function* () {
                return this.fetch({ url: '/api/participant/otut', type: 'POST', bypassCDN: false });
            });
        }
        static getHtml(options) {
            options = $.extend({}, { traditional: false, type: 'GET', secure: false, anonymous: false, data: {}, headers: {}, dataType: "html" }, options);
            const headers = $.extend({}, options.headers);
            const root = options.secure === true ? this.options.appUrlSecure : this.options.appUrl;
            const site = options.site !== false ? this.options.user.site + '/' : '';
            const xhr = $.ajax({
                dataType: options.dataType,
                url: `${root}${site}${options.url}`,
                contentType: 'application/json',
                type: options.type,
                headers: headers,
                traditional: options.traditional,
                timeout: options.timeout,
                data: options.type === "POST" ? JSON.stringify(options.data) : options.data
            });
            return xhr;
        }
        static postFile(options) {
            return __awaiter(this, void 0, void 0, function* () {
                options = $.extend({}, { secure: true, anonymous: false, data: {}, headers: {}, bypassCDN: false }, options);
                let headers = $.extend({}, options.headers);
                if (options.bypassCDN && !options.anonymous) {
                    const t = yield this.getOTUT();
                    headers = $.extend({}, { "PaxUID": t.token }, options.headers);
                }
                return yield $.ajax({
                    type: 'post',
                    url: options.bypassCDN ? this.options.appUrlBypassCDN + this.options.user.site + '/' + options.url : this.options.appUrl + this.options.user.site + '/' + options.url,
                    contentType: false,
                    headers: headers,
                    processData: false,
                    data: options.data
                });
            });
        }
        static track(code, type, label, value, data) {
            return this.getHtml({ type: "POST", url: 'api/tracker', data: { code: code, type: type, label: label, value: value, data: data } });
        }
        static trackPage(type, label, value, data) {
            return this.track(_a.TAG + '-' + this.options.user.site + '-Page-' + this.options.fileName, type, label, value, data);
        }
        static logTimings() {
            try {
                if (!(window.performance && window.performance.timing)) {
                    return;
                }
                const timings = {
                    url: window.location.pathname,
                    querystring: window.location.search,
                    hash: window.location.hash,
                    latency: window.performance.timing.responseStart - window.performance.timing.fetchStart,
                    transfer: window.performance.timing.responseEnd - window.performance.timing.responseStart,
                    domInteractive: window.performance.timing.domInteractive - window.performance.timing.domLoading,
                    domComplete: window.performance.timing.domComplete - window.performance.timing.domInteractive,
                    onLoad: window.performance.timing.loadEventEnd - window.performance.timing.loadEventStart,
                    browserHeight: window.innerHeight,
                    browserWidth: window.innerWidth,
                    devicePixelRatio: window.devicePixelRatio
                };
                this.getHtml({ type: 'POST', url: 'api/cerebro/ct', data: timings });
            }
            catch (e) { }
        }
        static add(i) {
            i();
        }
        static insertAtBeginning(i) {
            i();
        }
        static ready(i) {
            this.add(i);
        }
        static readyFirst(i) {
            this.insertAtBeginning(i);
        }
        static execute() {
            throw new Error("Method no longer available.");
        }
        static setNonEduVideoTracking() {
            const c = {};
            $('video:not([id^="snack"])').each((i, elem) => {
                c[i] = new NonEduVideoTracking(elem);
            });
        }
    },
    _a.TAG = "IREP7",
    _a.launchFullPageQuiz = FullPageQuiz.launchFullPageQuiz,
    _a.closeFullPageQuiz = FullPageQuiz.closeFullPageQuiz,
    _a.redirectAfterFullPageQuiz = FullPageQuiz.redirectAfterFullPageQuiz,
    _a);
IREP.initialize(readOptions(document.getElementById("irep-options")), window.irep);
